"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bigInteger_1 = require("../bigInteger");
const libs_1 = require("../libs");
class HexNumber {
}
HexNumber.hexNumberToNumber = (hexNumber) => {
    return Number(new bigInteger_1.BigInteger(libs_1.hexToBytes(hexNumber)).toString());
};
HexNumber.numberToHexNumber = (num) => {
    return libs_1.convertUint8ArrayToHexString(new bigInteger_1.BigInteger(num).toUint8Array());
};
exports.HexNumber = HexNumber;
